/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StarredFromLocalStorage
 */
export interface StarredFromLocalStorage {
  /**
   *
   * @type {string}
   * @memberof StarredFromLocalStorage
   */
  objectId: string;
  /**
   *
   * @type {string}
   * @memberof StarredFromLocalStorage
   */
  reason?: string | null;
}

/**
 * Check if a given object implements the StarredFromLocalStorage interface.
 */
export function instanceOfStarredFromLocalStorage(
  value: object,
): value is StarredFromLocalStorage {
  if (!("objectId" in value) || value["objectId"] === undefined) return false;
  return true;
}

export function StarredFromLocalStorageFromJSON(
  json: any,
): StarredFromLocalStorage {
  return StarredFromLocalStorageFromJSONTyped(json, false);
}

export function StarredFromLocalStorageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StarredFromLocalStorage {
  if (json == null) {
    return json;
  }
  return {
    objectId: json["objectId"],
    reason: json["reason"] == null ? undefined : json["reason"],
  };
}

export function StarredFromLocalStorageToJSON(
  json: any,
): StarredFromLocalStorage {
  return StarredFromLocalStorageToJSONTyped(json, false);
}

export function StarredFromLocalStorageToJSONTyped(
  value?: StarredFromLocalStorage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    objectId: value["objectId"],
    reason: value["reason"],
  };
}
